module.exports = __webpack_public_path__ + "img/argedis_splashscreen.258ad69.png";